var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLayerBike01 = function SvgLayerBike01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "layer_bike-01_svg2__a",
    x1: 27.81,
    x2: 167.29,
    y1: 131.27,
    y2: 40.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a70095"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#layer_bike-01_svg2__a",
    id: "layer_bike-01_svg2__b",
    x1: 33.59,
    x2: 173.07,
    y1: 140.12,
    y2: 49.01
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#layer_bike-01_svg2__a",
    id: "layer_bike-01_svg2__c",
    x1: 65.83,
    x2: 205.31,
    y1: 189.47,
    y2: 98.36
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M37.24 150.63c-14.07 0-25.52-11.45-25.52-25.52s10.75-24.81 24.22-25.49l9.33-10.88c-2.58-.57-5.27-.87-8.02-.87C16.71 87.87 0 104.57 0 125.11s16.71 37.24 37.24 37.24c14.18 0 26.53-7.97 32.82-19.66H55.71c-4.65 4.89-11.21 7.94-18.48 7.94Z",
    style: {
      fill: "url(#layer_bike-01_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.35 127.36a5.865 5.865 0 0 0 7.66 3.16c2.98-1.25 4.4-4.68 3.15-7.66l-28.95-69.49 12.85-4.29c3.07-1.02 4.73-4.34 3.7-7.41s-4.34-4.73-7.41-3.71l-18.83 6.28c-3.23 1.08-4.87 4.67-3.56 7.81l3.68 8.84-51.36 13.35-5.27-12.31h8.15c3.24 0 5.86-2.62 5.86-5.86s-2.62-5.86-5.86-5.86h-25.1c-3.24 0-5.86 2.62-5.86 5.86s2.62 5.86 5.86 5.86h4.2l7.8 18.2-35.28 41.16c-1.49 1.74-1.83 4.18-.87 6.26s3.04 3.41 5.32 3.41h56.48c1.87 0 3.63-.89 4.73-2.41l37.8-51.83 21.1 50.64Zm-107.37-8.11 23.24-27.11 11.62 27.11zm45.07-5.91L82.96 85.13l40.29-10.48-28.21 38.68Z",
    style: {
      fill: "url(#layer_bike-01_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m166.36 88.04 5.51 13.23c9.58 3.68 16.41 12.97 16.41 23.83 0 14.07-11.45 25.52-25.52 25.52s-25.52-11.45-25.52-25.52c0-3.67.78-7.15 2.18-10.31l-5.51-13.22c-5.24 6.42-8.39 14.61-8.39 23.53 0 20.53 16.71 37.24 37.24 37.24S200 145.63 200 125.1c0-19.32-14.79-35.25-33.64-37.07Z",
    style: {
      fill: "url(#layer_bike-01_svg2__c)"
    }
  }));
};
export default SvgLayerBike01;